import { type Common } from '../common.js';
import {
  type AssistantToolType,
  type ToolDefinition,
  type ToolDefinitionFindAllOptions,
} from '../models/assistant/toolDefinition/index.js';
import { type Sorts } from '../models/common.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/tool-definitions';
  }

  async findAll(options: {
    filter: ToolDefinitionFindAllOptions;
    sorts?: Sorts<{ id: string; creatd: string; name: string; type: AssistantToolType }>;
    page?: number;
    limit?: number;
  }): Promise<ToolDefinition[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }
}
